import { render, staticRenderFns } from "./CoolerCheckbox.vue?vue&type=template&id=9b241a14"
import script from "./CoolerCheckbox.vue?vue&type=script&lang=js"
export * from "./CoolerCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports